module.exports = __webpack_public_path__ + "static/zhongli-selected-73fbe5ee2a2b991063ffa34b51ba61e5.png";